// extracted by mini-css-extract-plugin
export default {"chip":"ChipWithCopy_chip__3YzYS","chipText":"ChipWithCopy_chipText__nC5RM","copied":"ChipWithCopy_copied__wmzDL"};